// extracted by mini-css-extract-plugin
module.exports = {"root":"CarouselCardImage_root__SO7zO","images":"CarouselCardImage_images__KzixU","inner":"CarouselCardImage_inner__WCg_a","button":"CarouselCardImage_button__mMxlx"};